import styled from 'styled-components';

export const StyledRequestsPopover = styled.div`
`;
